module.exports = __webpack_public_path__ + "static/media/picture-(234).9aa92260.JPG";